import ServiceUnavailable from '@/views/error/ServiceUnavailable';

export default [{ path: '/service/unavailable', component: ServiceUnavailable }];
